import {
  aChainRule,
  aFirstSeenRule,
  anAggregationRule,
  anOutlierRule,
  aRulePage,
  aRuleScoreMapping,
  aTemplatedMatchRule,
  aThresholdRule,
  mockRulesListQueryOperationQuery,
} from '__generated__';

import {
  AGGREGATION_RULE_DATA,
  CHAIN_RULE_DATA,
  FIRST_SEEN_RULE_DATA,
  MATCH_RULE_DATA,
  OUTLIER_RULE_DATA,
  SHARED_RULE_DATA,
  THRESHOLD_RULE_DATA,
} from './RuleBuilderQueryOperation.mocks';

export const rulesListQuery_chain = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            aChainRule({
              ...SHARED_RULE_DATA,
              name: CHAIN_RULE_DATA.updatedName,
              score: CHAIN_RULE_DATA.updatedScore,
              suppressionWindowSize: CHAIN_RULE_DATA.suppressionWindowSize,
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const rulesListQuery_match = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            aTemplatedMatchRule({
              ...SHARED_RULE_DATA,
              name: MATCH_RULE_DATA.updatedName,
              scoreMapping: aRuleScoreMapping({
                type: 'constant',
                default: MATCH_RULE_DATA.updatedScore,
              }),
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const rulesListQuery_threshold = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            aThresholdRule({
              ...SHARED_RULE_DATA,
              name: THRESHOLD_RULE_DATA.updatedName,
              score: THRESHOLD_RULE_DATA.updatedScore,
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const rulesListQuery_aggregation = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            anAggregationRule({
              ...SHARED_RULE_DATA,
              name: AGGREGATION_RULE_DATA.updatedName,
              scoreMapping: aRuleScoreMapping({
                type: 'constant',
                default: AGGREGATION_RULE_DATA.updatedScore,
              }),
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const rulesListQuery_firstSeen = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            aFirstSeenRule({
              ...SHARED_RULE_DATA,
              name: FIRST_SEEN_RULE_DATA.updatedName,
              score: FIRST_SEEN_RULE_DATA.updatedScore,
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const rulesListQuery_outlier = mockRulesListQueryOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          hasNextPage: false,
          objects: [
            anOutlierRule({
              ...SHARED_RULE_DATA,
              name: OUTLIER_RULE_DATA.updatedName,
              score: OUTLIER_RULE_DATA.updatedScore,
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const handlers = [
  mockRulesListQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage(),
      })
    );
  }),
];
